import '/assets/tailwind.css'

import { createApp } from 'vue'
import VueTippy from 'vue-tippy'
import 'tippy.js/dist/tippy.css'
import App from './App.vue'
import router from './router'
import { initializeSettings, store } from './store';
import CrispService from './services/crisp';
import * as Sentry from "@sentry/vue";

// Sentry.init({
//   app,
//   dsn: "https://2596a3a486dc026fd333ca6f64c96afb@o4508557819117568.ingest.de.sentry.io/4508557822459984",
//   // Adds request headers and IP for users, for more info visit:
//   // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/options/#sendDefaultPii
//   sendDefaultPii: false,
//   integrations: [
//   ],
// });

(async () => {
  let isAuthenticated = await initializeSettings();
  // if (!isAuthenticated) {
  //   router.push('/');
  // } 

  CrispService.init("531dfa94-390d-4997-a035-f488e1c1df29");
  CrispService.client.user.setEmail(store.email);

  // This is necessary to prevent the following warning that is coming up due to Sentry
  // "Crisp found shims of native JavaScript methods. This can alter the chatbox behavior 
  // and break things. Make sure not to override listed functions to ensure your chatbox 
  // works as expected. You may be looking for other JavaScript libraries in use on this page.
  // You can disable this warning by adding: $crisp.push(["safe", true]) to your page JavaScript.
  CrispService.client.setSafeMode(true);

  const app = createApp(App);

  Sentry.init({
    app,
    dsn: "https://7962487e9ce05f3ae2b85e6ae54f0480@o4508557819117568.ingest.de.sentry.io/4509253910855760",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    environment: getEnvironment()
  });

  app.use(router);
  app.use(
    VueTippy,
    {
      directive: 'tippy', // => v-tippy
      defaultProps: {
        //theme: 'custom',
        delay: [200], // [show delay, hide delay] in ms
        placement: 'auto',
      },
    }
  )
    // .use(TawkMessengerVue, {
    //   propertyId: '67c0c83530554d1913b89318',
    //   widgetId: '1il4gs4o8',
    // })
    .mount('#app')
})();

function getEnvironment() {
  return window.location.hostname.includes('dev.nevua.markets')
    ? 'development'
    : 'production';
}